import React from 'react';
import { Row, Col } from 'react-bootstrap';

const StatsSkeleton = () => {
    // Generate 4 placeholder cards
    return (
        <Row>
            {[1, 2, 3, 4].map((item) => (
                <Col xl={3} lg={6} sm={6} key={item}>
                    <div className="widget-stat card">
                        <div className="card-body p-4">
                            <div className="media">
                                <span className="me-3 bg-light rounded-circle" style={{ width: '50px', height: '50px', display: 'block' }}></span>
                                <div className="media-body">
                                    <div className="bg-light mb-2" style={{ width: '60%', height: '14px', borderRadius: '4px' }}></div>
                                    <div className="bg-light" style={{ width: '40%', height: '24px', borderRadius: '4px' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default StatsSkeleton;
